import React, { useState } from 'react';
import MonthYearValueBarGraphChart from '../../../../../../components/UI-Elements/Charts/MonthYearValueBarGraphChart/DateValueBarGraphChart';
import {
  MonthYearValue,
  createMonthYearValues,
  sumOfMonthYearArrayValues,
} from '../../../../../../utils/MonthYear/MonthYearValue';
import { MonthYear } from '../../../../../../utils/MonthYear/monthYear';

interface Props {
  quantity: number;
  duoDate: MonthYear;
  pricePerTonData: MonthYearValue[];
  singleYearView?: boolean;
  priceCalendar?: MonthYearValue[];
  setPriceCalendar: (data: MonthYearValue[]) => void;
}

export const DuoDateQuantityCalendar: React.FC<Props> = ({
  priceCalendar,
  setPriceCalendar,
  singleYearView = true,
}) => {
  const [quantityCalendarData, setQuantityCalendarData] = useState<MonthYearValue[]>(priceCalendar || []);
  // const [isFirstRender, setIsFirstRender] = useState(true);

  // useEffect(() => {
  //   if (isFirstRender) {
  //     if (!priceCalendar) {
  //       setQuantityCalendarData(DistributeValueThroughDates(quantity, duoDate));
  //       setPriceCalendar(DistributeValueThroughDates(quantity, duoDate));
  //     }
  //     setIsFirstRender(false);
  //   } else {
  //     setQuantityCalendarData(DistributeValueThroughDates(quantity, duoDate));
  //     setPriceCalendar(DistributeValueThroughDates(quantity, duoDate));
  //   }
  // }, [duoDate]);

  const updatePriceCalender = (data: MonthYearValue[]) => (setQuantityCalendarData(data), setPriceCalendar(data));

  return (
    <>
      <MonthYearValueBarGraphChart
        sumValueOfEditableProperty={sumOfMonthYearArrayValues(quantityCalendarData)}
        updateEditablePropertyFunc={updatePriceCalender}
        chartTypeToEdit={'bar'}
        singleYearView={singleYearView}
        barChartData={createMonthYearValues(11, 7, 2024, 3000)}
        graphChartData={createMonthYearValues(11, 7, 2024, 5000)}
        barChartTitle="Product Quantity"
        graphChartTitle="Material Quantity"
        changeGraphToBar={true}
        animationTime={500}
      />
    </>
  );
};
